import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {CreateDepositService} from '../../../../services/apiServices/business/create-deposit.service';
import {TranslateService} from '@ngx-translate/core';
import {BROWSERS, DeviceDetectorService} from 'ngx-device-detector';
import {KindOfUpload} from '../helpers/kind-of-upload.enum';
import {FileSaverService} from 'ngx-filesaver';
import {CommonService} from '../../../../services/apiServices/business/common.service';
import {color} from 'chart.js/helpers';
import {DepositDepotExpressEnum} from "../../../../enums/deposit.enums";

@Component({
  selector: 'app-deposit-review',
  templateUrl: './deposit-review.component.html',
  styleUrls: ['./deposit-review.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DepositReviewComponent implements OnInit {
  @Input() customizedFilePdf: any;
  @Input() depositDir: any;
  @Input() foldCount: any;
  @Input() type: string;
  useGrayColor: boolean = true;
  addAddressPage: boolean = false;
  public pdfToDisplay: any;
  public msBrowsers: boolean;
  public openVisualization: boolean;
  public setMargins: boolean;
  public showPaginator: boolean;
  public userMargins: number = 0;


  constructor(private createDepositService: CreateDepositService,
              private translate: TranslateService,
              private fileSaverService: FileSaverService,
              private commonService: CommonService,
              private deviceService: DeviceDetectorService) {
  }

  ngOnInit() {
    this.msBrowsers = (BROWSERS.IE === this.deviceService.getDeviceInfo().browser || BROWSERS.MS_EDGE === this.deviceService.getDeviceInfo().browser);
    if (this.customizedFilePdf) {
      const blob = KindOfUpload.b64toBlob(this.customizedFilePdf);
      this.pdfToDisplay = URL.createObjectURL(blob);
    }
    if (!this.foldCount) {
      this.foldCount = 1;
    }
    this.showPaginator = (this.type === DepositDepotExpressEnum.ERL ||this.type === DepositDepotExpressEnum.MAILING || this.type === DepositDepotExpressEnum.SPOOL) && this.foldCount > 1;
  }
  public loadVisualization(openModal: boolean): void {
    if (this.msBrowsers) {
      // TODO find how to preview on MS browsers
    } else {
      if (this.customizedFilePdf) {
        const blob = KindOfUpload.b64toBlob(this.customizedFilePdf);
        this.pdfToDisplay = URL.createObjectURL(blob);
        this.openVisualization = openModal;
      }
    }
  }
  public downloadDocument(): void {
    if (this.msBrowsers) {
      // TODO find how to preview on MS browsers
    } else {
      if (this.customizedFilePdf) {
        const blob = KindOfUpload.b64toBlob(this.customizedFilePdf);
        this.fileSaverService.save(blob, this.getDownloadFileName());
      }
    }
  }
  public getDownloadFileName(): string {
    const nowDate = new Date();
    const day = nowDate.getDate() < 10 ? ('0' + nowDate.getDate()) : '' + nowDate.getDate();
    const month = nowDate.getMonth() < 10 ? ('0' + nowDate.getMonth()) : '' + nowDate.getMonth();
    const year = nowDate.getFullYear();
    const hour = nowDate.getHours() < 10 ? ('0' + nowDate.getHours()) : '' + nowDate.getHours();
    const minute = nowDate.getMinutes() < 10 ? ('0' + nowDate.getMinutes()) : '' + nowDate.getMinutes();
    const second = nowDate.getSeconds() < 10 ? ('0' + nowDate.getSeconds()) : '' + nowDate.getSeconds();
    return `Visualisation_${year}-${month}-${day}_${hour}_${minute}_${second}.pdf`;
  }
  setExpressDepositMargins() {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    dataToSend.append('userMargin', '' + this.userMargins);
    dataToSend.append('grayColor', this.useGrayColor? 'Y' : 'N');
    dataToSend.append('addressPage', this.addAddressPage? 'Y' : 'N');
    this.createDepositService.setExpressDepositMargins(dataToSend).subscribe(response => {
      if (response.pdfFile) {
        this.customizedFilePdf = response.pdfFile;
        setTimeout(() => {
          this.pdfToDisplay = null;
          this.loadVisualization(false);
        }, 100);
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_MSG')
        });
      }
    });
  }

  initMargins() {
    if (this.setMargins) {
      this.userMargins = 5;
    }
    else {
      this.userMargins = 0;
    }
    this.setExpressDepositMargins();
  }
  paginate(pagination: any) {
    switch (this.type) {
      case DepositDepotExpressEnum.MAILING:
        this.prepareMailingFinalFile(pagination);
        break;
      case DepositDepotExpressEnum.SPOOL:
        this.prepareSpoolFinalFile(pagination);
        break;
      case DepositDepotExpressEnum.ERL:
        this.prepareErlFinalFile(pagination);
        break;
    }
  }
  prepareSpoolFinalFile(pagination: any) {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    dataToSend.append('foldNumber', '' + pagination.page);
    this.createDepositService.prepareSpoolFinalFile(dataToSend).subscribe(response => {
      if (response.pdfFile) {
        if (response.foldCount) {
          this.foldCount = response.foldCount;
        }
        this.customizedFilePdf = response.pdfFile;
        setTimeout(() => {
          this.pdfToDisplay = null;
          this.loadVisualization(false);
        }, 100);
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_MSG')
        });
      }
    });
  }
  prepareErlFinalFile(pagination: any) {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    dataToSend.append('foldNumber', '' + pagination.page);
    this.createDepositService.prepareErlFinalFile(dataToSend).subscribe(response => {
      if (response.pdfFile) {
        this.foldCount = response.foldCount;
        this.customizedFilePdf = response.pdfFile;
        setTimeout(() => {
          this.pdfToDisplay = null;
          this.loadVisualization(false);
        }, 100);
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_MSG')
        });
      }
    });
  }
  prepareMailingFinalFile(pagination: any) {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    dataToSend.append('foldNumber', '' + pagination.page);
    this.createDepositService.prepareMailingFinalFile(dataToSend).subscribe(response => {
      if (response.pdfFile) {
        if (response.foldCount) {
          this.foldCount = response.foldCount;
        }
        this.customizedFilePdf = response.pdfFile;
        this.foldCount = response.foldCount;
        setTimeout(() => {
          this.pdfToDisplay = null;
          this.loadVisualization(false);
        }, 100);
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_MSG')
        });
      }
    });

  }

  protected readonly color = color;
}
